import React from 'react';
import styled from 'styled-components';
import SearchBarContext from '../context';
import SuggestionEntry from './suggestion-entry';
import { saveEvent } from '../../../../../shared/search-event';

const fontSize = 14;

const Title = styled.h5`
  text-transform: uppercase;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: ${fontSize}px;
  color: ${props => props.theme.primaryColor};
  margin: 0;
`;

const Line = styled.div`
  text-transform: none;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: ${fontSize}px;
  margin: 0 -1em;
  padding: 0 1em;
  border-radius: 4px;
  color: ${props => props.theme.secondaryColor};
  background-color: ${props => (props.highlight ? props.theme.secondaryColorLight : 'white')};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export default function SuggestedSearches() {
  const {
    state: {
      caret, suggestions, rsearch, highlightedArea,
    },
    dispatch,
  } = React.useContext(SearchBarContext);

  const [highlight, setHighlight] = React.useState(caret - rsearch.length);

  React.useEffect(() => setHighlight(caret - rsearch.length), [caret, rsearch]);

  React.useEffect(() => {
    if (highlight !== -1 && caret >= rsearch.length) {
      dispatch({ type: 'setHighlightedArea', payload: 'suggested' });
    }
  }, [highlight, caret, rsearch.length, dispatch]);

  React.useEffect(() => {
    if (highlightedArea === 'recent') {
      setHighlight(-1);
    }
  }, [highlightedArea]);

  const performSearch = d => e => {
    e.preventDefault();
    saveEvent(d).finally(() => {
      dispatch({ type: 'setSuggestedSearchItem', payload: d });
      dispatch({ type: 'search', payload: d.suggested_term });
    });
  };

  return (
    <React.Fragment>
      <Title>suggested searches</Title>
      {suggestions.map((d, i) => (
        <Line
          key={`suggestion-line-${d.type}-${d.id}`}
          highlight={i === highlight}
          onClick={performSearch(d)}
          onMouseEnter={() => setHighlight(i)}
        >
          <SuggestionEntry {...d} />
        </Line>
      ))}
    </React.Fragment>
  );
}
